export default __webpack_public_path__ + "static/media/2025-woman-pantone.9c55bac4.png";